import {Grid, Link, useTheme,Box} from "@mui/material";
import { FormInput } from "../../../domains/common/components/FormInput";
import { FormInputDate } from "../../../domains/common/components/FormInput";
import React from "react";
import DealMenu from "../components/DealMenu";
import {Item} from "../../../domains/common/components/Item";
import RealtyFormContainer from "../components/Realty";
import {RolesEnums} from "../../../enums";
import {FilesListContainer} from "../components/FilesContainer";
import {XmlList} from "../components/XmlList";
import {Responsible} from "../components/Responsible";
import {dealData} from "../deal";
import { waitInputComplete } from "../../../fn";
import {ParticipantsComponent} from "../components/Participants";
import { CheckBoxWithLabel } from "../../../domains/common/components/FormInput";
import { DealExpressParam } from "../components/DealParams";
import { DealMilitaryParam } from "../components/DealParams";
import { ChildStatmentContainer } from "../components/ChildStatement";
import DealCommentContainer from "../components/Comment";

export function DealMortgageRegistrationContainer() {
  const theme = useTheme();

  return (
    <Grid container spacing={1} sx={{mt: 0.2}}>
      <Grid item xs={12}>
        <DealMenu dealId={dealData.dealId}></DealMenu>
      </Grid>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <RealtyFormContainer values={dealData.realty}/>
        </Item>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.DECLARANT} />
            </Item>
          </Grid>

          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <FilesListContainer />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <XmlList value={dealData?.dealXmlStatementsList} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <Responsible value={dealData.user} />
            </Item>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.REPRESENTATIVE} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.EXT_SIGNER} />
            </Item>
          </Grid>
            <Grid item xs={12}>
              <ChildStatmentContainer />
            </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <DealCommentContainer />
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export function DealMortgageRegistrationParamsContainer({onChange}) {
  const handleKuvdChange = waitInputComplete((e) => onChange({kuvdNumber: e.target.value}), 1500)
  const handleRegDate = (value) => {
    onChange({kuvdDate: value})
  }
  return (
    <Box sx={{display:'flex',flexDirection:'row',gap:2,alignItems:'flex-start'}}>
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      width: 'fit-content',
      height: '100px',
      overflow: 'auto'
    }}>
        <CheckBoxWithLabel
        inputProps={{className: `dealForm`}}
          label="Наличие ипотеки"
          name="dealWithMortgage"
        sx={{height: 30}}
          checked={!!dealData?.deal?.dealWithMortgage}
        onChange={(e) => onChange ? onChange({dealWithMortgage: e.target.checked}) : void 0}/>
        <DealExpressParam dealData={dealData} onChange={onChange} />
        <DealMilitaryParam dealData={dealData} onChange={onChange} />
      </Box>
    </Box>
  )
}
